export default "__VITE_ASSET__CVUH$Y5q__"